document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cross-sell-add]');
  if (!button || button.hasAttribute('disabled')) return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.setAttribute('aria-disabled', true);
  button.classList.add('loading');
  button.querySelector('.loading__spinner')?.classList.remove('hidden');

  const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const body = JSON.stringify({ items: [{ id: variantId, quantity: 1 }] });

  fetch(`${window.routes.cart_add_url}`, {
    ...fetchConfig('json'),
    body,
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        console.error(response.description || response.message);
        return;
      }

      return publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-cross-sell',
        cartData: response,
      }).then(() => {
        if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
    })
    .catch((e) => console.error(e))
    .finally(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      button.querySelector('.loading__spinner')?.classList.add('hidden');
    });
});
